import React from 'react';
import Auth from '../../lessonPlayer/services/AuthService';
import QuestionDependency from '../QuestionDependency';
import HtmlComponent from '../../lessonPlayer/components/HtmlComponent';

const ImageQuestion = ({ model, isManuscriptShort }) => {
  console.log('ImageQuestion model:', model);
  const imgSrc = `${Auth.ecms}/api/redirectToResource?contentItemId=${model.resourceContentItemId}&authKey=${Auth.authKey}`;

  return (
    <div className='element-container'>
      <div className='label-value-row'>
        <div>Activity Type:</div>
        <div>Image Activity</div>
      </div>
      <div className='label-value-row'>
        <div>Questions:</div>
        <div>{model.questionRange}</div>
      </div>
      <div className='label-value-row'>
        <div>Directions:</div>
        <div className='ckeditor-text'><HtmlComponent htmlStr={model.directions} /></div>
      </div>
      <div className='label-value-row'>
        <div>Image Title:</div>
        <div>{model.title}</div>
      </div>
      <img alt='' className='max-img-size' src={imgSrc} />
      {/* advanced options */}
      {!isManuscriptShort && (
        <>
          <QuestionDependency model={model} />
          <div className='label-value-row'>
            <div>Extra Class:</div>
            <div>{model.extraClass}</div>
          </div>
          <div className='label-value-row'>
            <div>Show All Items At Once:</div>
            <div>{(model.showAllChildren) ? 'ON' : 'OFF'}</div>

          </div>
        </>
      )}
    </div>
  );
};
export default ImageQuestion;
